var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechaDerecha(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52925 2.85932C5.7896 2.59898 6.21171 2.59898 6.47206 2.85932L11.1387 7.52599C11.3991 7.78634 11.3991 8.20845 11.1387 8.4688L6.47206 13.1355C6.21171 13.3958 5.7896 13.3958 5.52925 13.1355C5.2689 12.8751 5.2689 12.453 5.52925 12.1927L9.72451 7.9974L5.52925 3.80213C5.2689 3.54178 5.2689 3.11967 5.52925 2.85932Z",
    fill: "#FF4F00"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaDerecha);
export default __webpack_public_path__ + "static/media/flechaDerecha.ae5602f30a1eb200d573370a419752a6.svg";
export { ForwardRef as ReactComponent };